// @flow

import React, { Component } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import type { RouterHistory } from 'react-router';

import { clearToken } from 'helpers/auth';
import Chart from './components/Chart';
import SyndicateList from './components/SyndicateList';
import { fetchSyndicates, fetchMemberSyndicates } from 'actions/syndicate';
import type {
  FetchSyndicateFn,
  FetchMemberSyndicatesFn
} from 'actions/syndicate';

type Props = {
  history: RouterHistory,
  fetchSyndicates: FetchSyndicateFn,
  fetchMemberSyndicates: FetchMemberSyndicatesFn,
  mySyndicates: Array<any>,
  memberSindicates: Array<any>
};

class SyndicateDashboard extends Component<Props> {
  componentDidMount() {
    this.props.fetchSyndicates();
    this.props.fetchMemberSyndicates();
  }

  render() {
    const { history, mySyndicates, memberSyndicates } = this.props;

    return (
      <Grid centered>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Button
              size="large"
              onClick={() => {
                clearToken();
                history.push('/');
              }}
            >
              Logout
            </Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Button size="large" onClick={() => history.push('/new')}>
              Create New Syndicate
            </Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Chart data={mySyndicates} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ marginTop: '100px' }}>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <div>
              <h3>My Syndicates</h3>
              <SyndicateList syndicates={mySyndicates} />
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <h3>Member Syndicates</h3>
            <SyndicateList syndicates={memberSyndicates} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  mySyndicates: state.mySyndicates.map(id => state.entities.syndicates[id]),
  memberSyndicates: state.memberSyndicates
    .map(id => state.entities.memberSyndicates[id])
    .map(member => ({
      memberId: member.id,
      ...state.entities.syndicates[member.syndicate]
    }))
});

export default connect(
  mapStateToProps,
  { fetchSyndicates, fetchMemberSyndicates }
)(SyndicateDashboard);



// WEBPACK FOOTER //
// ./src/screens/SyndicateDashboard/index.js